import { render } from "./AlertBar.vue?vue&type=template&id=4d280747"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__